import styled from 'styled-components'
import vars from '@/scss/variables.js'

const { redwebmotors, white } = vars

export const Stamp = styled.div`
    display: flex;
    display: none;
    align-items: center;
    justify-content: center;
    height: 20px;
    background-color: ${redwebmotors};
    border-radius: 100px;
    color: ${white};
    padding: 0 16px;
    font-size: 10px;
    letter-spacing: 0.02em;
    white-space: nowrap;
    strong{
        margin-left: 3px;
    }
`

export const SantanderLogo = styled.span`
    background-image: url('/public/assets/img/santander_icon_white.svg');
    background-position: center center;
    background-repeat: no-repeat;
    margin-left: 8px;
    width: 14px;
    height: 14px;
`
